export const AuthorSearchType = Object.freeze({
  InternalId: 0,
  Last: 1,
  First: 2,
  References: 3
})
